import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

export function Modal({ children, onClose, fullPage, fullHeight }) {
  useEffect(() => {
    if (!onClose) return;
    let listener = (e) => {
      e.stopPropagation();
      return e.key == "Escape" && onClose();
    };

    // capture is useful, so, if you have both a modal and a panel open, escape closes
    // the modal, and stopPropagation before hitting panel
    document.addEventListener("keydown", listener, { capture: true });
    return () =>
      document.removeEventListener("keydown", listener, { capture: true });
  }, []);
  const ref = useRef();

  useEffect(() => {
    const input = ref?.current?.querySelector("input");
    if (input) {
      input.focus();
    }
  }, []);

  return createPortal(
    <div
      className={
        "w-screen h-screen flex items-center justify-center fixed top-0 left-0 p-3"
      }
      onClick={onClose}
      style={{ background: "rgba(0, 0, 0, 0.5)", zIndex: 1000 }}
    >
      <div
        className={
          "bg-white rounded shadow p-3 overflow-y-auto overflow-x-hidden relative min-w-full md:min-w-0"
        }
        style={{
          maxWidth: "90%",
          maxHeight: "90%",
          height: fullHeight ? "100%" : "unset",
          width: fullPage ? "90%" : 500,
        }}
        onClick={(e) => e.stopPropagation()}
        ref={ref}
      >
        {onClose && (
          <div
            style={{ position: "absolute", top: 0, right: 0 }}
            className={"p-3 px-4 cursor-pointer hover:text-gray-600"}
            onClick={onClose}
          >
            <span className={"fa fa-times"} />
          </div>
        )}
        {children}
      </div>
    </div>,
    document.getElementById("overlays")
  );
}
